import { Button, Col, Row, Stack } from "react-bootstrap";
import { Suspense } from "react";
import { Await, useRouteLoaderData } from "react-router-dom";
import { renderTrendIcon } from "../helperRenders";
import { BarChartLineFill } from "react-bootstrap-icons";
import { toAutoDecimals } from "../HelperFunctions";

export default function CompetitorChartRow({ item, virtualizer, virtualRow, setCatalogueSong, setTrendSong, radioIds }) {
    const { competitorRadios } = useRouteLoaderData("root");

    return (
        <Row
            data-index={virtualRow?.index}
            ref={virtualizer.measureElement}
            style={{ transform: `translateY(${virtualRow?.start - virtualizer?.options.scrollMargin}px)` }}
            className={`py-1 border-bottom  position-absolute w-100 hoverable`}
            onClick={() => setCatalogueSong(item)}>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.artist}
            </Col>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.title}
            </Col>
            <Col xs={2} xl={1} className=" align-content-center text-center d-none d-xl-block px-xl-2">
                {item.release_year}
            </Col>
            <Col xs={12} className="d-xl-none">
                <Stack direction="horizontal" gap={1} className=" fw-bold flex-wrap">
                    <span>{item.artist}</span>
                    <span>-</span>
                    <span>{item.title}</span>
                    {item.release_year && <span>({item.release_year})</span>}
                </Stack>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            <Col xs={"auto"} xl={1} className=" align-content-center text-center px-xl-2">
                <span className=" d-xl-none">Market Spins: </span>
                <span className=" fw-bold fw-xl-normal">{item.spins}</span>
            </Col>
            <Col xs={"auto"} xl={1} className=" align-content-center text-center px-xl-2">
                <span className=" d-xl-none">Average Spins: </span>
                <span className=" fw-bold fw-xl-normal">{toAutoDecimals(item.average_spins, 0)}</span>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            {radioIds.map((x, i) => (
                <Col key={x} xs={"auto"} xl={1} className=" d-flex align-items-center justify-content-center column-gap-1 text-center px-xl-2">
                    <span className=" d-xl-none">
                        <Suspense>
                            <Await resolve={competitorRadios}>
                                {resolvedRadios => (resolvedRadios.data.find(rr => rr.radio_id === x)?.radio_name ?? "Unknown") + ":"}
                            </Await>
                        </Suspense>
                    </span>
                    {item.radio_spins[i]?.spins > 0 && (
                        <>
                            <span className=" fw-bold fw-xl-normal">{item.radio_spins[i]?.spins} </span>
                            <span className="d-flex">{renderTrendIcon(item.radio_spins[i]?.trend)}</span>
                        </>
                    )}
                </Col>
            ))}
            <Col xs={12} className="d-xl-none"></Col>
            <Col className="text-center align-content-center px-xl-0" xs={"auto"} xl={1}>
                <Button
                    className=" btn-ra-yellow py-1"
                    size="sm"
                    onClick={e => {
                        e.stopPropagation();
                        setTrendSong(item);
                    }}>
                    <BarChartLineFill /> Trend
                </Button>
            </Col>
        </Row>
    );
}
